module.exports = __webpack_public_path__ + "img/live_finished.32d3150f.svg";